import { Card, Space, Table, Typography } from 'antd';
import PropTypes from 'prop-types';
import { formatNumber } from '@/common/utils/format';
import {
  filterMetricItemsByPlatform,
  formatAnalysisTimestamp,
  formatDelta,
  getDeltaTextType,
  getMetricTitle,
} from '../utils/analysis';
import { formatTraceAccountName } from '../utils/platform';

const accountMetricColumns = [
  {
    dataIndex: 'title',
    width: '20%',
    render: (_, metric) => (
      <Typography.Text type="secondary">{getMetricTitle(metric.key)}</Typography.Text>
    ),
  },
  {
    align: 'right',
    dataIndex: 'value',
    width: '40%',
    render: (value) => <Typography.Text strong>{formatNumber(value || 0)}</Typography.Text>,
  },
  {
    dataIndex: 'delta',
    width: '40%',
    render: (delta) => (
      <Space size="small">
        <Typography.Text styles={{ root: { fontSize: 10 } }} type="secondary">
          较上周
        </Typography.Text>
        <Typography.Text styles={{ root: { fontSize: 10 } }} type={getDeltaTextType(delta)}>
          {formatDelta(delta)}
        </Typography.Text>
      </Space>
    ),
  },
];

const AnalysisAccountMetricCard = ({ account }) => (
  <Card
    extra={formatAnalysisTimestamp(account.asOf)}
    size="small"
    styles={{ extra: { fontSize: 10 } }}
    type="inner"
    title={formatTraceAccountName(account)}
  >
    <Table
      columns={accountMetricColumns}
      dataSource={filterMetricItemsByPlatform(account.metrics, account.platform)}
      pagination={false}
      rowKey="key"
      showHeader={false}
      size="small"
      tableLayout="fixed"
    />
  </Card>
);

AnalysisAccountMetricCard.propTypes = {
  account: PropTypes.shape({
    accountKey: PropTypes.string,
    asOf: PropTypes.number,
    metrics: PropTypes.arrayOf(
      PropTypes.shape({
        delta: PropTypes.number,
        key: PropTypes.string,
        title: PropTypes.string,
        value: PropTypes.number,
      }),
    ),
    name: PropTypes.string,
    platform: PropTypes.string,
  }).isRequired,
};

export default AnalysisAccountMetricCard;
